import { createRestApiClient } from '..';
import { getUserToken } from '../../Utils/helper';
const restApiClient = createRestApiClient();

export const getGrowthData = async (week) => {
  const restApiClient = createRestApiClient(true);
  const params = { week: week, user_type: 2 };
  const data = await restApiClient
    .request({
      method: 'GET',
      url: 'api/getGrowthTrackerNew',
      headers: {
        authorization: `${getUserToken(true)}`,
      },
      params: params,
    })
    .then((res) => res.data?.data);
  return data;
};

export const getPregnancyQuestions = async (page) => {
  const data = await restApiClient
    .request({
      method: 'GET',
      url: `api/getFeeds?filter=post&page=${page}&type=featured&tag=1919`,
    })
    .then((res) => res.data);
  return data;
};

export const getBirthClubData = async () => {
  const data = await restApiClient
    .request({
      method: 'GET',
      url: `api/getPregnancyBirthClubs`,
    })
    .then((res) => res.data);
  return data;
};
// export const useGetWeek = (week) => {
//     const {
//         data: weekData,
//         error,
//         mutate,
//     } = useSWR(path, () => getGrowthData(week), {
//         revalidateOnMount: false,
//         revalidateOnFocus: false,
//     });

//     return { weekData, error, mutate };
// };
